<script setup lang="ts">
/**
 * Dumb stepper component, act as layout only for Step component
 * */
</script>

<template>
  <div class="flex z-1 justify-between overflow-y-clip overflow-x-auto">
    <slot></slot>
  </div>
</template>
